import { View } from 'react-native'
import styled, { useTheme } from 'styled-components'
import { FadingArrowCarousel } from '../../../elements/carousels/FadingArrowCarousel/FadingArrowCarousel'
import { FilmPoster } from '../FilmPoster/FilmPoster'

const Slide = styled(View)`
  padding: 0 ${(props) => props.theme.spacing.xsmall}px;
  align-items: center;
`

export const FilmCarousel = (props) => {
  const theme = useTheme()
  const gutter = theme.spacing.xsmall * 2
  return (
    <FadingArrowCarousel
      {...props}
      responsive={{
        lg: { slidesToShow: 8, slidesToScroll: 6 },
        md: { slidesToShow: 6, slidesToScroll: 4 },
        sm: { slidesToShow: 4, slidesToScroll: 2 },
        xs: { slidesToShow: 3, slidesToScroll: 1 },
      }}
      keyExtractor={(item) => item.slug}
      renderItem={(item, _, width) => (
        <Slide>
          <FilmPoster item={item} width={width - gutter} />
        </Slide>
      )}
    />
  )
}
